<kodit-dropdown
  [formCtrlId]="formCtrlId"
  [options]="items"
  ctrlTooltip="Izaberite prikaz otpremnice"
  ctrlTooltipPosition="top"
  [formCtrl]="formCtrl"
></kodit-dropdown>
